import moment from 'moment';

const statusColors: Record<string, string> = {
  CLOSED: '#4CAF50',
  DUPLICATE: '#FF5722',
  FIXED: '#2196F3',
  INVALID: '#F44336',
  NEW: '#FFC107',
  OPEN: '#03A9F4',
  REOPEN: '#9C27B0',
};

export const CardLogs: React.FC<{
  number: number;
  status_before: string;
  status_after: string;
  updatedBy?: string;
  updatedAt: string;
}> = ({ number, status_before, status_after, updatedBy, updatedAt }) => {
  const formattedDate = moment(updatedAt).format('D MMMM YYYY');

  return (
    <div className="flex w-full gap-2 p-2 border rounded">
      <strong>{number}.</strong>
      <div className="flex flex-col w-full gap-1 ">
        <div className="font-semibold">
          Issue status changed from{' '}
          <span style={{ color: statusColors[status_before] || 'black' }}>
            {status_before}
          </span>{' '}
          to{' '}
          <span style={{ color: statusColors[status_after] || 'black' }}>
            {status_after}
          </span>
        </div>
        <div className="flex justify-between">
          <span>
            Updated by <strong className="capitalize">{updatedBy}</strong>{' '}
          </span>
          <span>{formattedDate}</span>
        </div>
      </div>
    </div>
  );
};
